module.exports = __webpack_public_path__ + "media/אשפה.e1d81afc.mp3";